import * as React from "react";
import { CourseInstructionPartOperations } from "../../../../../../course-author/instruction/parts/CourseInstructionPart.types";
import { courseInstructionPartViews } from "../../../../../../../utils/courseViews";
import { PreferredLocale } from "../../../../../../../utils/locales";
import { ExerciseWrapper } from "../../../../../../course-author/instruction/parts/exercises/ExerciseWrapper";
import { IClozeExercise } from "../../../../../../course-author/types";
import ToggleDisplay from "../../../../../../utils/ToggleDisplay";
import ClozePreview from "./ClozePreview";
import EditCloze from "./EditCloze";
import { convertBackendTemplateToFrontendFormat, FrontendGapTag } from "./util";

export interface IClozeExercisePartProps {
  clozeExercisePart: IClozeExercise;
  currentLocale: PreferredLocale;
  edit: boolean;
  partOperations: CourseInstructionPartOperations;
}

export const ClozeExercisePart: React.FC<IClozeExercisePartProps> = props => {
  const { currentLocale, clozeExercisePart, partOperations } = props;

  const gaps = courseInstructionPartViews.clozeExercisePart.localizedGaps(clozeExercisePart, currentLocale) || [];
  const template =
    courseInstructionPartViews.clozeExercisePart.localizedTemplate(clozeExercisePart, currentLocale) || "";
  const pieces = convertBackendTemplateToFrontendFormat(template)
    .split(FrontendGapTag)
    .map((prefix, i) => ({ prefix, gap: gaps[i] }));

  return (
    <ExerciseWrapper
      exercisePart={clozeExercisePart}
      currentLocale={currentLocale}
      edit={props.edit}
      partOperations={partOperations}
    >
      <ToggleDisplay shouldDisplay={!props.edit}>
        <ClozePreview pieces={pieces} />
      </ToggleDisplay>
      <ToggleDisplay shouldDisplay={props.edit}>
        <EditCloze currentLocale={currentLocale} gaps={gaps} partOperations={partOperations} template={template} />
      </ToggleDisplay>
    </ExerciseWrapper>
  );
};
